import React, { Component } from 'react';
import PropTypes from 'prop-types'
import languages from './../constants/languages';
import * as Global from './../constants/Global';

import './../css/react-flags-select.css';

class ReactLangSelect extends Component {
	constructor(props){
		super(props);

		const defaultLanguage = languages[this.props.defaultLanguage] && this.props.defaultLanguage;

		this.state = {
			openOptions: false,
			defaultLanguage,
			filteredLanguages: []
		}
		this.selectedFlag = React.createRef();
		this.flagOptions = React.createRef();
		this.filterText = React.createRef();
		this.toggleOptions = this.toggleOptions.bind(this);
		this.closeOptions = this.closeOptions.bind(this);
		this.onSelect = this.onSelect.bind(this);
		this.filterSearch = this.filterSearch.bind(this);
		this.setLanguages = this.setLanguages.bind(this);
	}

	toggleOptions() {
		!this.state.disabled && this.setState({
			openOptions: !this.state.openOptions
		});
	}

	toggleOptionsWithKeyboard(evt) {
		evt.preventDefault();
		if (evt.keyCode === 13) {
			//enter key: toggle options
			this.toggleOptions();
		} else if (evt.keyCode === 27) {
			//esc key: hide options
			!this.state.disabled && this.setState({
				openOptions: false
			});
		}

	}

	closeOptions(event) {
		if (event.target !== this.selectedFlag.current && event.target !== this.flagOptions.current && event.target !== this.filterText.current) {
			this.setState({
				openOptions: false
			});
		}
	}

	onSelect(langCode) {
		this.setState({
			selected: langCode,
			filter : ''
		})
		this.props.onSelect && this.props.onSelect(langCode);
	}

	onSelectWithKeyboard(evt, langCode) {
		evt.preventDefault();
		if (evt.keyCode === 13) {
			//enter key: select
			this.onSelect(langCode);
			this.closeOptions(evt);
		} else if (evt.keyCode === 27) {
			//esc key: hide options
			this.toggleOptions();
		}
	}

	updateSelected(langCode) {
		let isValid = languages[langCode];

		isValid && this.setState({
			selected: langCode
		})
	}

	filterSearch(evt) {
		let filterValue = evt.target.value;
		let filteredLanguages = filterValue && this.state.languages.filter(key => {
			let label = this.props.customLabels[key] || languages[key];
			return  label && label.match(new RegExp(filterValue, 'i'))
		}) ;

		this.setState({filter : filterValue, filteredLanguages : filteredLanguages });
	}

	setLanguages() {
		const fullLanguages = Object.keys(languages);

		let selectLanguages = this.props.languages && this.props.languages.filter( lang => {
			return languages[lang] ;
		});

		//Filter BlackList
		if (this.props.blackList && selectLanguages) {
			selectLanguages = fullLanguages.filter(langKey =>{
					return selectLanguages.filter(lang =>{
						return langKey === lang;
					}).length === 0
			});
		}

		this.setState({
			languages: selectLanguages || fullLanguages
		}, ()=> {
			const { selected } = this.state;

			if (selected && !this.state.languages.includes(selected)) {
				this.setState({ selected: null });
			}
		});
	}

	componentDidMount() {
		this.setLanguages();
		!this.props.disabled && window.addEventListener("click", this.closeOptions);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.languages !== this.props.languages || prevProps.blackList !== this.props.blackList) {
			this.setLanguages();
		}
	}

	componentWillUnmount() {
		!this.props.disabled && window.removeEventListener("click", this.closeOptions);
	}

	render() {

		let isSelected = this.state.selected || this.state.defaultLanguage;
		let selectedSize = this.props.selectedSize;
		let optionsSize = this.props.optionsSize;
		let alignClass = this.props.alignOptions.toLowerCase() === 'left' ? 'to--left' : '';

		return (
			<div className={`flag-select ${this.props.className ? this.props.className :  ""}`} style={this.props.style}>
				<div ref={this.selectedFlag} style={{fontSize: `${selectedSize}px`}} className={`selected--flag--option ${this.props.disabled ? 'no--focus' : ''}`} tabIndex="0" onClick={this.toggleOptions} onKeyUp={evt => this.toggleOptionsWithKeyboard(evt)}>
					{isSelected &&
						<span className="country-flag" style={{width: `${selectedSize}px`, height: `${selectedSize}px`}} >
							<img src={Global.flagUrl + `svg/${isSelected.toLowerCase()}.svg`} alt={isSelected}/>
							{this.props.showSelectedLabel &&
								<span className="country-label">{ this.props.customLabels[isSelected] || languages[isSelected] }</span>
							}
						</span>
					}

					{!isSelected &&
						<span className="country-label">{this.props.placeholder}</span>
					}
					<span className={`arrow-down ${this.props.disabled ? 'hidden' : ''}`}>▾</span>
				</div>

				{this.state.openOptions &&
					<div ref={this.flagOptions} style={{fontSize: `${optionsSize}px`}} className={`flag-options ${alignClass}`}>
						{this.props.searchable &&
							<div className="filterBox">
								<input type="text" placeholder={this.props.searchPlaceholder} ref={this.filterText}  onChange={this.filterSearch}/>
							</div>
						}
						{(this.state.filter ? this.state.filteredLanguages : this.state.languages).map( langCode =>
							<div className={`flag-option ${this.props.showOptionLabel ? 'has-label' : ''}`} key={langCode} tabIndex="0" onClick={() => this.onSelect(langCode)} onKeyUp={evt => this.onSelectWithKeyboard(evt, langCode)}>
								<span className="country-flag" style={{width: `${optionsSize}px`, height: `${optionsSize}px`}} >
									<img src={Global.flagUrl + `svg/${langCode.toLowerCase()}.svg`} alt="" />
									{this.props.showOptionLabel &&
										<span className="country-label">{ this.props.customLabels[langCode] || languages[langCode] }</span>
									}
								</span>
							</div>
						)}
					</div>
				}
			</div>
		)
	}
}

ReactLangSelect.defaultProps = {
	selectedSize: 16,
	optionsSize: 14,
	placeholder: "Select a language",
	showSelectedLabel: true,
	showOptionLabel: true,
	alignOptions: "right",
	customLabels: {},
	disabled: false,
	blackList: false,
	searchable: false,
	searchPlaceholder: 'Search',
}

ReactLangSelect.propTypes = {
	languages: PropTypes.array,
	blackList: PropTypes.bool,
	customLabels: PropTypes.object,
	selectedSize: PropTypes.number,
	optionsSize: PropTypes.number,
	defaultLanguage: PropTypes.string,
	placeholder: PropTypes.string,
	className: PropTypes.string,
	showSelectedLabel: PropTypes.bool,
	showOptionLabel: PropTypes.bool,
	alignOptions: PropTypes.string,
	onSelect: PropTypes.func,
	disabled: PropTypes.bool,
	searchable: PropTypes.bool,
	searchPlaceholder: PropTypes.string,
}

export default ReactLangSelect;
